/**
 * Created by Gaplo917 on 9/7/2017.
 */
import * as PIXI from "pixi.js";
import R from "../config/R"

export default class Button extends PIXI.Sprite {
  constructor(x, y, texture, rolloverEffect = true){
    super(texture)
    this.anchor.x = 0.5
    this.anchor.y = 0.5
    this.x = x
    this.y = y
    this.rolloverEffect = rolloverEffect
  }

  addOnClickListener(fn) {
    this.interactive = true
    this.buttonMode = true

    this
      .on('mousedown', () => {
        this.touchEffect(true)
      })
      .on('mouseup', (e) => {
        this.touchEffect(false)
      })
      .on('mouseover', () => {
        if(this.rolloverEffect){
          this.touchEffect(true)
        }
      })
      .on('mouseout', () => {
        this.touchEffect(false)
      })
      .on('touchstart', () => {
        this.touchEffect(true)
      })
      .on('touchend', () => {
        this.touchEffect(false)
      })
      .on('touchendoutside', (e) => {
        this.touchEffect(false)
      })
      .on('touchcancel', (e) => {
        this.touchEffect(false)
      })
      .on('touchend', (e) => {
        this.touchEffect(false)
      })
      .on('tap', (e) => {
        fn(e)
      })
      .on('click', (e) => {
        fn(e)
      })

  }

  touchEffect(enabled = false){
    if(enabled){
      this.alpha = 0.7
    }
    else {
      this.alpha = 1.0
    }
  }

  removeOnClickListener(){
    this.interactive = false
    this.buttonMode = false

    this
      .removeListener('mousedown')
      .removeListener('touchstart')
      .removeListener('mouseup')
      .removeListener('touchend')

  }
}



// WEBPACK FOOTER //
// ./src/game/objects/Button.js